import React from 'react';
import { Skeleton } from 'fronton-react';
import { akinatorCompletionsPreloaderWrap } from './akinator-skeleton-styles';

export const AkinatorSkeleton = () => {
  return (
    <div className={akinatorCompletionsPreloaderWrap}>
      <Skeleton width="72px" height="32px" variant="control" roundingSize="l" />
      <Skeleton width="72px" height="32px" variant="control" roundingSize="l" />
      <Skeleton width="72px" height="32px" variant="control" roundingSize="l" />
    </div>
  );
};
